export enum PosthogFeatureFlagName {
	SHARE_GIST = "share_gist",
	SHARE_QUIZ = "share_quiz",
	EXPORT_NOTE = "export_note",
	FOLDERS = "folders",
	BETA = "beta",
	PREMIUM = "premium",
	REFERRALS = "referrals",
	QUIZ_MATCHING = "quiz_matching",
	QUIZ_ORDERING = "quiz_ordering",
	GOOGLE_LOGIN = "google_login",
	TIKTOK_LOGIN = "tiktok_login",
	MICROSOFT_LOGIN = "microsoft_login",
	SIDE_DRAWER = "side_drawer",
}

export type PosthogEventContext =
	| "landing_page"
	| "signup_flow"
	| "login_flow"
	| "onboarding_flow"
	| "profile_settings"
	| "flashcard_preview"
	| "gist_preview"
	| "note_preview"
	| "quiz_preview"
	| "notes_flow"
	| "flashcards_flow"
	| "gists_flow"
	| "quizzes_flow"
	| "subscription_flow";

export type PosthogEventObject =
	| "user"
	| "study_kit"
	| "login"
	| "flashcards"
	| "note"
	| "gist"
	| "quiz"
	| "import_button"
	| "share_button"
	| "page"
	| "password_reset"
	| "purchase_order";

type PosthogEventAction =
	| "viewed"
	| "prompted"
	| "created"
	| "requested"
	| "deleted"
	| "confirmed"
	| "cancelled"
	| "clicked"
	| "engaged"
	| "imported"
	| "logged_in"
	| "onboarded";

/**
 * Generate a standardized PostHog event name based on context, object, and action.
 * @param {PosthogEventContext} context The context of the event. E.g., "signup_flow".
 * @param {PosthogEventObject} object The object of the event. E.g., "user".
 * @param {PosthogEventAction} action The action of the event. E.g., "created".
 * @returns {string} The formatted event name.
 */
export const makePosthogEventName = (
	context: PosthogEventContext,
	object: PosthogEventObject,
	action: PosthogEventAction
) => {
	return `${context}:${object}:${action}`;
};
